import axios from "axios";

export default function getInstantWinLoyaltyPoint({
  uuid,
  product_uuids,
  start,
  length,
  search,
}) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/campaignV2/customer/loyaltyPoint/availableInstantWin`, {
        uuid,
        product_uuids,
        start,
        length,
        search,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
